import { LangRestrictionStatusSchema } from "@/modules/admin/objects/langRestriction";
import { z } from "zod";
import { QcBizStaffGroupStateSchema } from "../Staff";

// This type is used for the tags which show in submenus of /hotel_admin_function
// https://jaqool.atlassian.net/browse/KTZNCHAT-3838
export type SUBMENU_TYPE_FOR_TAG =
  | "BOT"
  | "ANNOUNCEMENT"
  | "YELP"
  | "TRIP_ADVISOR"
  | "COUPON"
  | "FACILITY"
  | "FLOOR_MAP"
  | "CONGESTION"
  | "QUESTIONNAIRE"
  | "URL"
  | "ORDER"
  | "VOICE_TALK"
  | "QR_ORDER"
  | "ONLINE_PAYMENT"
  | "AI_CHATBOT"
  | "GUEST_SMS_CHAT";

// Note: yes, this is really what it's called
export enum SubMenuSubMenuType {
  announcement = "bot_type", // bot_type
  facility = "facility_information_type", //Facility Information Type facility_information_type
}

export type SubMenuUrl = z.infer<typeof SubMenuUrlSchema>;
export const SubMenuUrlSchema = z.object({
  id: z.number(),
  sub_menu_id: z.number(),
  url: z.string(),
});

export type SubMenu = z.infer<typeof SubMenuSchema>;
export const SubMenuSchema = z.object({
  id: z.number().nullable(),
  tenant_id: z.number().nullable(),
  name_dict: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  menu_type: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  menu_option: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  is_display: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  url: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  pms_verification_required: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  not_show_list_inside: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  facility_id: z.number().optional(),
  is_lang_restricted: z
    .boolean()
    .optional()
    .transform((value) => value ?? false),
  qr_order_url: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
  sub_menu_type: z
    .string()
    .optional()
    .transform((value) => value ?? ""),
});

export type QcBizSubMenu = z.infer<typeof QcBizSubMenuSchema>;
export const QcBizSubMenuSchema = z.object({
  admin_name: z.string().optional(),
  admin_name_dict: z.string().optional(),
  current_lang_cd: z.string().optional(),
  facility_id: z.number().optional(),
  id: z.number().optional(),
  lang_restriction_status: LangRestrictionStatusSchema.optional(),
  menu_option: z.string().optional(),
  menu_type: z.string().optional(),
  name: z.string().optional(),
  name_dict: z.string().optional(),
  not_show_list_inside: z.boolean().optional(),
  pms_verification_required: z.boolean().optional(),
  qr_order_url: z.string().optional(),
  staff_groups: z.array(QcBizStaffGroupStateSchema).optional(),
  sub_menu_type: z.string().optional(),
  tenant_id: z.number().optional(),
  url: z.string().optional(),
});

export type SubMenuDictRelation = z.infer<typeof SubMenuDictRelationSchema>;
export const SubMenuDictRelationSchema = z.object({
  menu_type: z.string().optional(),
  name: z.string().optional(),
  sub_menu_id: z.number().optional(),
});

export type SubMenuDictRelations = z.infer<typeof SubMenuDictRelationsSchema>;
export const SubMenuDictRelationsSchema = z.object({
  sub_menu_relations: z.array(SubMenuDictRelationSchema).optional(),
});

export type QcBizSubMenuForQcBizInquiry = z.infer<typeof QcBizSubMenuForQcBizInquirySchema>;
export const QcBizSubMenuForQcBizInquirySchema = z.object({
  id: z.number().nullable(),
  name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  name_dict: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  tenant_id: z.number().nullable(),
});
